export default __webpack_public_path__ + "static/media/495.4b059961.gif";